import { render, staticRenderFns } from "./Xz.vue?vue&type=template&id=d747081a&scoped=true&"
import script from "./Xz.vue?vue&type=script&lang=js&"
export * from "./Xz.vue?vue&type=script&lang=js&"
import style0 from "./Xz.vue?vue&type=style&index=0&id=d747081a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d747081a",
  null
  
)

export default component.exports